// Library Imports
import { Col, Row } from 'antd';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
// Local Imports
import { routes } from '../constants';
import { resetWorkflow } from '../actions';
import AutomationItemCard from './AutomationItemCard';
import AutomationVideoCard from './AutomationVideoCard';
// Icon Imports
import Action from '../../../assets/img/icons/Action.svg';
import Events from '../../../assets/img/icons/Events.svg';
import Conditions from '../../../assets/img/icons/Conditions.svg';
import { ReactComponent as ArrowLine } from '../../../assets/img/icons/ArrowGreen.svg';

const AutomationOnBoarding: React.FC = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(resetWorkflow());
  }, []);

  return (
    <Wrapper>
      <h2>Setup Marketing Automation</h2>
      <p>Automate your email outreach through our simple drag-and-drop builder.</p>
      <div className="wrapper-onboard">
        <Row justify="start" gutter={[24, 24]}>
          <Col span={12}>
            <AutomationItemCard title="Events" subText="Events kick off the execution of your workflow." icon={Events} />
          </Col>
          <Col span={12}>
            <AutomationItemCard title="Conditions" subText="Specify conditions that must be met for your workflow to continue." icon={Conditions} />
          </Col>
          <Col span={12}>
            <AutomationItemCard title="Actions" subText="Tasks that should be performed after a condition is met." icon={Action} />
          </Col>
          <Col span={12}>
            <AutomationVideoCard />
          </Col>
          <Col span={24}>
            <Link to={routes.CREATE} className="create-flow">
              Start creating your Workflow <ArrowLine />
            </Link>
          </Col>
        </Row>
      </div>
    </Wrapper>
  );
};

export default AutomationOnBoarding;

const Wrapper = styled.div`
  h2 {
    color: #424b50;
    font-weight: 700;
    font-family: 'Roboto Slab', serif;
    font-size: 26px;
    margin: 21px 0 6px 0;
    display: block;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 20px;
    }
  }
  p {
    color: #7e7e7e;
    font-weight: 400;
    font-size: 18px;
    font-family: 'Roboto', sans-serif;
    display: block;
    margin: 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 14px;
    }
  }
  .wrapper-onboard {
    max-width: 730px;
    display: block;
    margin: 72px 0 40px 0;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      margin: 50px 0 30px 0;
      max-width: 650px;
    }
  }
  .create-flow {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    color: #27ce0a;
    text-decoration: underline;
  }
`;
